import {priceStyles} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";

priceStyles.productPrice = {
    price: {
        priceText: { size: 20 },
        unitOfMeasureText: { size: 20 },
    },
}